<template>
  <div
    id="change-delivery-number-modal"
    tabindex="-1"
    aria-hidden="true"
    data-modal-backdrop="static"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full"
  >
    <div class="relative w-full max-w-2xl">
      <!-- Modal content -->
      <div class="relative pt-4 pb-2 bg-gray-200 rounded-lg shadow ">
        <!-- Modal header -->

        <div class="px-4 flex items-center justify-between pb-2 mb-2 border-b border-gray-200 rounded-t sm:mb-2 ">
          <h3 v-if="input?.mode == 'display'" class="font-semibold text-gray-900 text-lg ">{{ labels["TITLE_EDIT_DELIVERY_NUMBER"][lg] }} {{ input?.source?.delivery_number }}</h3>
          <h3 v-if="input?.mode == 'create'" class="font-semibold text-gray-900 text-lg ">
            {{ labels["TITLE_CREATE_DELIVERY"][lg] }}
          </h3>
          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click="onClose()"
          >
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <div class="relative bg-gray-50 rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4">
          <div class="w-full flex flex-col">
            <div class="mt-2 w-full flex">
              <div class="text-left justify-start mr-2 flex flex-row items-center py-2">
                <label for="game_specie_id" class="w-36 block text-sm font-semibold text-gray-900 "> {{ labels["TITLE_ENTITY"][lg] }} </label>
                <select
                  id="hunting-item-nemrod_comment_id"
                  v-model="entity_id"
                  :disabled="input?.mode == 'display'"
                  class="w-72 border border-gray-300 text-gray-900 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block p-2"
                  :class="{ 'bg-gray-50': input?.mode == 'create', 'bg-gray-200': input?.mode == 'display' }"
                  @change="onEntityChanged"
                >
                  <option v-for="entity in filteredEntities" :key="entity._id" :value="entity._id">{{ entity.name }}</option>
                </select>
              </div>
            </div>

            <hr />

            <div class="mt-2 w-full flex">
              <div class="text-left justify-start mr-2 flex flex-row items-center py-2">
                <label for="hunting-item-number" class="w-36 block max-w-36 text-sm font-semibold text-gray-900  mr-2"> {{ labels["TITLE_DONE_AT"][lg] }} </label>
                <ContentDate
                  mode="edit"
                  :id="`content-date-input-${id}-delivery-report`"
                  class="max-w-36"
                  ref="content-date-input-delivery-report"
                  :config="config_date"
                  index="200"
                  placeholder=""
                  :value="received_at"
                  @update-field="onDateValueChanged"
                  @value-changed="onDateValueChanged"
                />
              </div>
            </div>

            <hr />
            <div class="mt-2 w-full flex">
              <div class="text-left justify-start mr-2 flex flex-row items-center py-2 w-full">
                <label for="game_specie_id" class="w-36 max-w-36 block text-sm font-semibold text-gray-900 "> {{ labels["TITLE_NEW_DELIVERY_NUMBER"][lg] }}</label>
                <button
                  id="delivery_number_dropdown_button"
                  data-dropdown-toggle="delivery_number_dropdown"
                  type="button"
                  @click="onDropdownDeliveryOpen"
                  class="flex w-48 max-w-48 items-center justify-between text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5   "
                >
                  <span>{{ current_delivery_number }}</span>
                  <svg class="w-2.5 h-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4" />
                  </svg>
                </button>

                <!-- Dropdown menu -->
                <div id="delivery_number_dropdown" class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 ">
                  <ul class="max-h-96 overflow-auto py-2 text-sm text-gray-700 " aria-labelledby="dropdownDefaultButton">
                    <li
                      v-for="delivery in deliveries"
                      :key="delivery.name"
                      :class="{ 'text-gray-200 pointer-events-none cursor-none': delivery.status == 'NOK', 'text-gray-800 cursor-pointer': delivery.status == 'OK' }"
                      @click="selectDeliveryNumber(delivery)"
                    >
                      <div class="block px-4 py-2 hover:bg-gray-100 ">{{ delivery.name }} - {{ delivery.status }}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="mt-2 w-full flex"></div>

            <div class="w-full flex flex-row mt-6 py-2"></div>
          </div>
          <div class="absolute top-0 left-0 w-full h-full bg-gray-50 flex items-center justify-center" :class="{ block: !show_form, hidden: show_form }">
            <div class="flex items-center">
              <div role="status">
                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin  fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
              <div class="font-bold text-lg ml-2">Chargement en cours</div>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-between px-4">
          <div class="text-gray-500 italic text-xs">*128*</div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose()"
            >
              Annuler
            </button>
            <button
              type="button"
              :disabled="disabledValidate"
              class="inline-flex items-center text-white font-bold rounded-lg text-sm px-5 py-2.5 text-center  "
              :class="{ 'bg-gray-400': disabledValidate, 'bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300': !disabledValidate }"
              @click="onValidate"
            >
              MODIFIER
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labels from "@/assets/lg/hunting-batch.json";
import ContentDate from "@/components/content/ContentDate.vue";
import service from "@/services/FullService.vue";
import { mapGetters } from "vuex";
import { Dropdown } from "flowbite";
export default {
  name: "DeliveryNumberChangeModal",
  props: {
    input: Object,
  },
  components: {
    ContentDate,
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    filteredEntities: function () {
      if (this.user?.entity_id == undefined) return this.entities;
      if (this.user?.entity_id == "") return this.entities;
      if (this.user.entity_id == "all") return this.entities;

      let user = this.user;

      if (this.entities == undefined) return [];
      if (this.entities?.length == 0) return [];

      let entity = this.entities.find((a) => a._id === user.entity_id);

      let a = [];
      a.push(entity);

      //  this.entity_id =this.user.entity_id
      return a;
    },
    disabledValidate: function () {
      //   console.log("entity_id =", this.entity_id, ", received_at=", this.received_at, ", current_delivery_number=", this.current_delivery_number);

      if (this.entity_id == undefined) return true;
      if (this.entity_id == "") return true;

      if (this.received_at == undefined) return true;
      if (this.received_at == "") return true;

      if (this.current_delivery_number == undefined) return true;
      if (this.current_delivery_number == "") return true;
      console.log("==== false");
      //if (this.weight_gross == "") return true;
      return false;
    },

    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
  },
  data() {
    return {
      lg: "FR",
      labels: labels,
      price: "",
      current_delivery_number: "-",
      mode: "",
      deliveries: [],
      record_deliveries: [],
      id: null,
      show_form: false,
      config_date: null,
      entities: [],
      vets: [],
      members: [],
      received_at: null,
      entity_id: null,
      dropdownDeliveryButton: null,
      value: "",
    };
  },
  watch: {
    received_at: async function () {
      this.current_delivery_number = "-";

      await this.loadDeliveries();
    },
    filteredEntities: async function () {
      if (this.user.entity_id != null && this.user.entity_id != "all") this.entity_id = this.user.entity_id;
      else if (this.entities.length == 1) this.entity_id = this.entities[0]._id;
    },
    input: async function () {
      this.id = this.input?.id;
      this.value = this.input?.delivery_number;
      this.received_at = this.input?.received_at;
      this.$nextTick(() => {});

      await this.loadDeliveries();
      if (this.entities.length == 0) {
        await this.loadEntities();
      }
      this.current_delivery_number = "-";
      this.received_at = this.formatDate(this.input?.source?.received_at);

      if (this.input?.source?.entity_id != null) {
        this.entity_id = this.input?.source?.entity_id;
      } else {
        if (this.user.entity_id != null && this.user.entity_id != "all") {
          this.entity_id = this.user.entity_id;
        } else if (this.entities.length == 1) {
          this.entity_id = this.entities[0]._id;
        }
      }
      this.show_form = false;
      this.view = this.input?.view;
      this.show_form = true;
    },
  },
  async mounted() {
    this.id = this.input?.id;
    this.value = this.input?.delivery_number;
    this.received_at = this.input?.source?.received_at;
    this.$nextTick(() => {});
  },

  methods: {
    formatDate(d) {
      if (d == undefined) return;
      let s = d.split("T");

      let ss = s[0].split("-");
      return ss[0] + "-" + ss[1] + "-" + ss[2];
    },
    async onDateValueChanged(val) {
      this.received_at = val;

      this.current_delivery_number = "-";
      await this.loadDeliveries();
    },
    async loadEntities() {
      {
        //inbound-pricing-lists
        let datasource = "66a4a20e8d43c894c147758d";

        let filters = {};
        let collection = "data-sources/" + datasource + "/records?limit=500";
        let entities = await service.getData(collection, this.user?.token, filters);

        this.entities = entities.records;
      }
    },
    buildStatusArray(input, opts = {}) {
      const arr = Array.isArray(input) ? input : [];
      const names = arr.map((x) => x?.name).filter(Boolean);
      const present = new Set(names);

      // --- Préfixe (ex: "BA-A-25211-") ---
      let prefix;
      if (names.length) {
        // retire le dernier segment numérique (compteur)
        const sample = names[0];
        prefix = sample.replace(/-\d{2,}$/, "-");
      } else {
        const brand = String(opts.brand || "BA").toUpperCase();
        const letter = /^(A|S)$/i.test(opts.letter) ? opts.letter.toUpperCase() : "A";
        const d = opts.date ? new Date(opts.date) : new Date();
        if (isNaN(d)) throw new Error("opts.date invalide");

        const yy = String(d.getFullYear() % 100).padStart(2, "0"); // 25
        const ddd = String(getDayOfYear(d)).padStart(3, "0"); // 211
        const yyddd = yy + ddd; // 25211
        prefix = `${brand}-${letter}-${yyddd}-`;
      }

      // --- borne supérieure du compteur ---
      const nums = names
        .map((n) => {
          const m = n.match(/-(\d{2,})$/);
          return m ? parseInt(m[1], 10) : null;
        })
        .filter((n) => n != null);

      const last = nums.length ? Math.max(...nums) : 0;
      const maxNum = Math.max(last + 5, 5); // au moins 5 éléments

      // --- génération depuis 01 ---
      const out = [];
      for (let i = 1; i <= maxNum; i++) {
        const name = prefix + String(i).padStart(2, "0");
        out.push({ name, status: present.has(name) ? "NOK" : "OK" });
      }
      return out;

      function getDayOfYear(date) {
        const start = new Date(date.getFullYear(), 0, 1);
        return Math.floor((date - start) / 86400000) + 1;
      }
    },
    onDropdownDeliveryOpen() {
      {
        // set the dropdown menu element
        const $targetEl = document.getElementById("delivery_number_dropdown");

        // set the element that trigger the dropdown menu on click
        const $triggerEl = document.getElementById("delivery_number_dropdown_button");

        // options with default values
        const options = {
          placement: "bottom",
          triggerType: "click",
          offsetSkidding: 0,
          offsetDistance: 10,
          delay: 300,
          ignoreClickOutsideClass: false,
          onHide: () => {
        
          },
          onShow: () => {
 
          },
          onToggle: () => {
           
          },
        };

        // instance options object
        const instanceOptions = {
          id: "delivery_number_dropdown",
          override: true,
        };
        /*
         * $targetEl: required
         * $triggerEl: required
         * options: optional
         * instanceOptions: optional
         */
        this.dropdownDeliveryButton = new Dropdown($targetEl, $triggerEl, options, instanceOptions);
        this.dropdownDeliveryButton.show();
      }
    },

    selectDeliveryNumber(delivery) {
      if (delivery.status == "NOK") {
        this.current_delivery_number = "-";
        return;
      }

      this.current_delivery_number = delivery.name;
      this.dropdownDeliveryButton.hide();
    },

    getDate(d) {
      if (d == undefined) return "";
      return d.split("T")[0];
    },

    async loadDeliveries() {
      if (this.user?.tenant_id == "6533fe68b1f4342903409c00") {
        if (this.received_at == undefined) this.received_at = this.input?.source?.received_at;

        let deliveries = [];
        //inbound-pricing-lists
        let datasource = "68a6473e7208fabe38717ee6";
        //
        let filters = {
          received_at: this.getDate(this.received_at),
          entity_id: this.input?.source?.entity_id,
          limit: 500,
        };

        let collection = "data-sources/" + datasource + "/records";
        deliveries = await service.getData(collection, this.user?.token, filters); //

        this.record_deliveries = deliveries?.records;

        if (deliveries?.records != undefined) {
          deliveries = deliveries.records;
        }

        let letter = "A";

        if (this.input?.source?.entity_id == "66a4a19c8d43c894c147758a") letter = "A";
        if (this.input?.source?.entity_id == "66a4a1cb8d43c894c147758b") letter = "S";

        let opt = { letter: letter, date: filters.received_at };

        this.deliveries = this.buildStatusArray(deliveries, opt);
      }
    },

    onValidate() {
      let item = {
        id: this.id,
        delivery_number: this.input.delivery_number,
        input: this.input,
        entity_id: this.entity_id,
        action: this.input.action,
        target: {
          delivery_number: this.current_delivery_number,
        },
      };

      this.show_form = false;
      this.$emit("confirm", item);
      // this.name = ""
    },

    onClose() {
      this.show_form = false;
      this.$emit("close");
    },
  },
};
</script>
